import { __ } from '@wordpress/i18n';
import Control from './Control';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes }) => {
  return (
    <>
      <Control
        attributes={attributes}
        setAttributes={setAttributes}
      />

      <div className='Input-label'>
        <input type="checkbox" className="Checkbox" />
        <RichText
          tagName="p"
          className="Checkbox-text"
          placeholder={__("Preencha o texto da checkbox")}
          value={attributes.text}
          onChange={(text) => { setAttributes({ text }) }}
        />
      </div>
    </>
  );
}
